import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerGeneralDetailsRequest extends BaseUpdateRequest {
	emergencyContactName: string;     
    emergencyContactPhoneNumber: string;
}